<template>
  <v-app id="app_authentication">
    <v-navigation-drawer
      class="custom_navigation_drawer"
      width="30%"
      :image="require('@/img/background_images/banner_1.png')"
      v-model="drawer"
      app
    ></v-navigation-drawer>

    <v-main class="custom_border_with_small_devices custom_class_alignment">
      <v-container color="white" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="12" md="2"></v-col>
          <v-col cols="12" sm="12" md="8">
            <v-card flat style="background: transparent !important;">
              <template v-slot:title>
                <v-card-title class="custom_topic_sign_in">
                  Log In
                </v-card-title>
              </template>

              <!-- FIXED: Logos now properly aligned using flex container -->
              <template v-slot:append>
                <div class="logo-container">
                  <img
                    class="logo-item"
                    :src="require('@/img/company_logo/logo-dark 2.png')"
                    alt="Company Logo"
                  />
                  <img
                    class="logo-item"
                    :src="require('@/img/company_logo/g-sfa.png')"
                    alt="G-SFA Logo"
                  />
                </div>
              </template>

              <v-divider class="mt-2 mb-6 mr-4 ml-4"></v-divider>

              <v-card-text class="mt-5">
                <v-form ref="form" v-model="valid">
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="loginInput"
                        :error-messages="loginInputErrors"
                        :class="{ 'error-field': loginInputFieldError }"
                        :rules="loginInputRules"
                        autocomplete="username"
                        color="#546E7A"
                        clearable
                        label="Email or Username"
                        placeholder="Email or Username"
                        prepend-inner-icon="mdi mdi-account-outline"
                        required
                        variant="outlined"
                        @keyup.enter="submit"
                        @input="clearLoginInputError"
                        @focus="clearLoginInputError"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12">
                      <v-text-field
                        v-model="password"
                        :append-inner-icon="e1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :error-messages="passwordErrors"
                        :class="{ 'error-field': passwordFieldError }"
                        :rules="passwordRules"
                        :type="e1 ? 'text' : 'password'"
                        autocomplete="current-password"
                        label="Password"
                        min="8"
                        color="#546E7A"
                        placeholder="Password"
                        prepend-inner-icon="mdi-lock-outline"
                        required
                        variant="outlined"
                        @click:append-inner="e1 = !e1"
                        @keyup.enter="submit"
                        @input="clearPasswordError"
                        @focus="clearPasswordError"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>

                <div class="text-subtitle-1 text-medium-emphasis d-flex align-center justify-space-between">
                  <v-spacer></v-spacer>
                  <p class="custom_paragraph_option_2 mb-8">
                    <router-link class="custom_link custom_class_text_decoration_none" to="/forgot_password">
                      <v-icon left>mdi mdi-lock-reset</v-icon>
                      Forgot password?
                    </router-link>
                  </p>
                </div>

                <v-row align="center" justify="center">
                  <v-col sm="12" md="12">
                    <v-btn
                      @click="submit"
                      :loading="cardLoader"
                      size="x-large"
                      block
                      style="background-color: #800080; color: white;"
                    >
                      <v-icon size="large" start>mdi-account-arrow-right-outline</v-icon>
                      Continue
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-divider class="mt-2 mb-6 mr-4 ml-4"></v-divider>

              <v-card-subtitle class="mt-2">
                <div>
                  <p class="custom_paragraph_option_2 text-center">
                    POWERED BY CELATATECH
                  </p>
                </div>
              </v-card-subtitle>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="2"></v-col>
        </v-row>
      </v-container>

      <v-snackbar
        v-model="snackAlert.snackbar"
        :color="snackAlert.snackColor"
        :right="snackAlert.snackBarRight"
        :top="snackAlert.snackBarTop"
        timeout="3000"
      >
        {{ snackAlert.snackMessage }}
      </v-snackbar>
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";
import { encryptData } from "@/utils/crypto";

export default {
  name: "LoginPage",
  data() {
    return {
      valid: false,
      drawer: null,
      window: {
        width: 0,
        height: 0
      },

      snackAlert: {
        snackbar: false,
        snackColor: "",
        snackMessage: "",
        snackBarRight: true,
        snackBarTop: true,
      },

      password: "",
      passwordErrors: [],
      passwordFieldError: false,
      passwordRules: [v => !!v || "Password is required"],

      loginInput: "",
      loginInputErrors: [],
      loginInputFieldError: false,
      loginInputRules: [
        v => !!v || 'Email or Username is required',
        v => v.length >= 3 || 'Must be at least 3 characters'
      ],

      cardLoader: false,
      e1: false,
    };
  },

  beforeUnmount() {
    clearInterval(this.interval);
  },

  unmounted() {
    window.removeEventListener("resize", this.handleResize);
  },

  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },

  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },

    isEmail(input) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(input);
    },

    clearLoginInputError() {
      this.loginInputFieldError = false;
      this.loginInputErrors = [];
    },

    clearPasswordError() {
      this.passwordFieldError = false;
      this.passwordErrors = [];
    },

    validateForm() {
      let isValid = true;

      this.loginInputFieldError = false;
      this.passwordFieldError = false;
      this.loginInputErrors = [];
      this.passwordErrors = [];

      if (!this.loginInput) {
        this.loginInputFieldError = true;
        this.loginInputErrors = ['Email or Username is required'];
        this.showSnackbar("Please enter your email or username.", "error");
        isValid = false;
      } else if (this.loginInput.length < 3) {
        this.loginInputFieldError = true;
        this.loginInputErrors = ['Must be at least 3 characters'];
        this.showSnackbar("Email or username must be at least 3 characters.", "error");
        isValid = false;
      }

      if (!this.password) {
        this.passwordFieldError = true;
        this.passwordErrors = ['Password is required'];
        this.showSnackbar("Please enter your password.", "error");
        isValid = false;
      }

      return isValid;
    },

    async submit() {
      if (this.cardLoader) {
        return;
      }

      if (!this.validateForm()) {
        return;
      }

      this.cardLoader = true;

      try {
        const response = await axios.post(`/api/login`, {
          login: this.loginInput,
          password: this.password
        });

        if (response.data.validate === "success") {
          this.showSnackbar("Login Successful. Redirecting...", "success");

          // 1. Store the FULL login response (for sidebar permissions)
          localStorage.setItem("loginResponse", JSON.stringify(response.data));

          // 2. Store user details
          localStorage.setItem("userId", response.data.user.id);
          localStorage.setItem("token", response.data.access_token);
          localStorage.setItem("userName", response.data.user.user_name);
          localStorage.setItem("email", response.data.user.email);
          localStorage.setItem("user_details", JSON.stringify(response.data.user));
          localStorage.setItem("userType", response.data.user.user_type);

          // 3. Store mobile numbers if available
          if (response.data.user.mobile_number && response.data.user.mobile_number.length > 0) {
            localStorage.setItem("mobileNumbers", response.data.user.mobile_number[0].mobile_number);
          }

          // 4. Store permissions in MULTIPLE places for redundancy
          if (response.data.accessDashboard) {
            localStorage.setItem("permissions", JSON.stringify(response.data.accessDashboard));
            localStorage.setItem("userPermissions", JSON.stringify(response.data.accessDashboard));
            localStorage.setItem("accessDashboard", encryptData(response.data.accessDashboard));
          }

          console.log("✅ Login successful. Permissions saved:", response.data.accessDashboard?.length || 0);

          // Redirect based on user permissions
          const accessDashboard = response.data.accessDashboard;
          if (accessDashboard && accessDashboard.length > 0) {
            const dashboardPathMap = {
              1: { read: "/dashboard", write: "/dashboard" },
              2: { read: "/products-list", write: "/add-products" },
              3: { read: "/leads-list", write: "/add-leads" },
              4: { read: "/users-list", write: "/user-registration" },
              5: { read: "/sales-management", write: "/sales-management" },
              6: { read: "/total-collections", write: "/Collection-Bulk-Upload" },
              7: { read: "/live-tracking", write: "/live-tracking" },
              8: { read: "/routes-list", write: "/create-routes" },
              9: { read: "/outlet-list", write: "/create-outlet" },
              11: { read: "/sales-management", write: "/sales-management" },
              12: { read: "/user-log", write: "/user-log" },
            };

            const hasFlag = (value) => Number(value) === 1 || value === true;

            let redirected = false;

            for (const dashboard of accessDashboard) {
              const dashboardId = dashboard.dashboard_id;

              if (dashboardPathMap[dashboardId]) {
                if (hasFlag(dashboard.read_premission)) {
                  this.$router.push({ path: dashboardPathMap[dashboardId].read });
                  redirected = true;
                  break;
                } else if (hasFlag(dashboard.write_premission)) {
                  this.$router.push({ path: dashboardPathMap[dashboardId].write });
                  redirected = true;
                  break;
                }
              }
            }

            if (!redirected) {
              this.showSnackbar("No valid dashboard access found.", "error");
            }
          } else {
            this.showSnackbar("No dashboard access configured for this user.", "error");
          }
        } else if (response.data.validate === "user_deleted") {
          this.showSnackbar(response.data.message || "This account has been deleted.", "error");
          this.highlightServerErrors(response.data);
        } else if (response.data.validate === "invalid_credentials") {
          this.showSnackbar("Invalid credentials. Please check your email/username and password.", "error");
          this.highlightServerErrors(response.data);
        } else if (response.data.validate === "invalid_password") {
          this.passwordFieldError = true;
          this.passwordErrors = ['Incorrect password'];
          this.showSnackbar("Incorrect password. Please try again.", "error");
        } else if (response.data.validate === "invalid_user") {
          this.loginInputFieldError = true;
          this.loginInputErrors = ['Invalid username or email'];
          this.showSnackbar("You are not authorized to access the web portal.", "error");
        } else if (response.data.validate === "user_deactivated") {
          this.showSnackbar(response.data.message || "This account has been deactivated.", "error");
          this.highlightServerErrors(response.data);
        } else {
          this.showSnackbar(response.data.message || "Login failed. Please try again.", "error");
          this.highlightServerErrors(response.data);
        }
      } catch (error) {
        if (error.response) {
          const data = error.response.data;
          if (data.validate === "user_deleted") {
            this.showSnackbar(data.message || "This account has been deleted.", "error");
          } else if (data.validate === "invalid_credentials") {
            this.loginInputFieldError = true;
            this.passwordFieldError = true;
            this.loginInputErrors = ['Invalid email/username'];
            this.passwordErrors = ['Invalid password'];
            this.showSnackbar(data.message || "Invalid credentials provided.", "error");
          } else if (data.validate === "invalid_password") {
            this.passwordFieldError = true;
            this.passwordErrors = ['Incorrect password'];
            this.showSnackbar(data.message || "Incorrect password.", "error");
          } else if (data.validate === "validation_failed") {
            this.showSnackbar(data.message || "Please fill in all required fields correctly.", "error");
            this.highlightServerErrors(data);
          } else {
            this.showSnackbar(data.message || "An error occurred. Please try again.", "error");
          }
        } else {
          this.showSnackbar("An error occurred. Please try again later.", "error");
        }
      } finally {
        this.cardLoader = false;
      }
    },

    highlightServerErrors(data) {
      if (data.errors) {
        if (data.errors.login) {
          this.loginInputFieldError = true;
          this.loginInputErrors = Array.isArray(data.errors.login) ? data.errors.login : [data.errors.login];
        }
        if (data.errors.password) {
          this.passwordFieldError = true;
          this.passwordErrors = Array.isArray(data.errors.password) ? data.errors.password : [data.errors.password];
        }
      }

      if (!data.errors || (!data.errors.login && !data.errors.password)) {
        if (data.validate === "invalid_credentials") {
          this.loginInputFieldError = true;
          this.passwordFieldError = true;
        }
      }
    },

    showSnackbar(message, color) {
      this.snackAlert.snackbar = true;
      this.snackAlert.snackMessage = message;
      this.snackAlert.snackColor = color;
    }
  },
};
</script>

<style lang="scss" scoped>
@use "../styles/auth/authentication.scss" as *;

/* Logo alignment fix */
.logo-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  height: 100%;
  padding-right: 8px;
}

.logo-item {
  display: block;
  object-fit: contain;
  width: auto;
  height: 65px;
}

/* Specific widths for each logo */
.logo-item:first-child {
  width: 220px;
}

.logo-item:last-child {
  width: 100px;
}

/* Error field styling */
.error-field input {
  border-color: #ff0000 !important;
}

.error-field .v-field__outline {
  border-color: #ff0000 !important;
}

.error-field .v-field__field {
  border-color: #ff0000 !important;
}

.error-field .v-field {
  background-color: rgba(255, 0, 0, 0.02);
}
</style>